import format from 'date-fns/format';
import parse from 'date-fns/parse';
import qs from 'qs';

import langs from '../../webpack/constants/langs';

import {
  DEFAULT_RESELLERS,
  VIEW_APP_PARAMS,
  VIEW_APP_UPDATE_TYPE,
  NOT_EXIST_COUNTRIES,
} from 'constants/common';
import COUNTRIES from 'dicts/countries';
import trackError from 'utility/trackError';

export function getIsOpenedInWebView(location) {
  const { search = '' } = location;

  const { view } = qs.parse(search, { ignoreQueryPrefix: true });
  return view === 'app';
}

export function getLangFromUrl(url) {
  const urlParts = url.split('/');
  return urlParts.find((urlPart) => langs.some((lang) => lang === urlPart));
}

export function getLandingKey(url) {
  const lang = getLangFromUrl(url);
  const urlParts = url.split('/').filter((urlPart) => urlPart && urlPart !== lang);
  return urlParts.join('/');
}

export function reloadPage() {
  if (typeof window !== 'undefined') {
    window.location.reload();
  }
}

export function getDefaultResellerForLocale(lang = 'ru') {
  return DEFAULT_RESELLERS[lang];
}

export function copyToClipboard(data) {
  if (document && data) {
    const el = document.createElement('textarea');
    el.value = data;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  }
}

export function getCurrentPageUrl(options) {
  if (typeof window !== 'undefined') {
    const port = window.location.port || '';
    const hostUrlPart = `${window.location.protocol}//${window.location.hostname}${
      port ? ':' + port : ''
    }`;
    const pathUrlPart = `${window.location.pathname}${options.hash || ''}`;
    return `${hostUrlPart}${pathUrlPart}`;
  }

  return '';
}

export function testOttDomain() {
  if (typeof window !== 'undefined') {
    const { hostname } = window.location;
    const testDomainRegExp = /solartrip/i;

    return testDomainRegExp.test(hostname);
  }

  return true;
}

export function handleViewAppLink(url, queryParams, action) {
  let resultingUrl = url;
  switch (action.type) {
    case VIEW_APP_UPDATE_TYPE.UPDATE_LINK:
      resultingUrl = updateLinkHandler();
      break;
    case VIEW_APP_UPDATE_TYPE.UPDATE_DEEPLINK:
      if (canUseDeeplink()) {
        resultingUrl = updateDeeplinkHandler();
      } else {
        resultingUrl = updateLinkHandler();
      }
      break;
    case VIEW_APP_UPDATE_TYPE.REPLACE_APPLINK:
      if (canUseDeeplink()) {
        resultingUrl = replaceApplinkHandler();
      } else {
        resultingUrl = updateLinkHandler();
      }
      break;
    default:
      break;
  }

  return resultingUrl;

  function updateLinkHandler() {
    const urlSeparator = url.indexOf('?') < 0 ? '?' : '&';
    const urlParameters = VIEW_APP_PARAMS.reduce((result, param) => {
      const value = queryParams[param];
      if (value) {
        return [...result, `${param}=${value}`];
      }
      return result;
    }, []).join('&');
    const urlHash = action.hash ? '#' + action.hash : '';

    if (urlParameters.length > 0) {
      return url + urlSeparator + urlParameters + urlHash;
    } else {
      return url + urlHash;
    }
  }

  function updateDeeplinkHandler() {
    const apiVersion = '' + queryParams.ottApiVersion;
    const title = action.data && action.data.title ? action.data.title : '';

    switch (apiVersion) {
      case '1':
      default:
        return (
          queryParams.deeplinkScheme +
          '://www.solartrip.com/webview/?title=' +
          title +
          '&openInBrowser=true&link=' +
          encodeURIComponent(url)
        );
    }
  }

  function replaceApplinkHandler() {
    const apiVersion = '' + queryParams.ottApiVersion;

    switch (apiVersion) {
      case '1':
      default:
        return queryParams.deeplinkScheme + '://' + action.data.link;
    }
  }

  function canUseDeeplink() {
    return queryParams.ottApiVersion && queryParams.deeplinkScheme;
  }
}

export function getRuWeekdayByIndex(weekdayIndex) {
  const weekdays = [
    'Понедельник',
    'Вторник',
    'Среда',
    'Четверг',
    'Пятница',
    'Суббота',
    'Воскресенье',
  ];

  if (weekdayIndex < 0 || weekdayIndex > weekdays.length - 1) {
    return null;
  }

  return weekdays[weekdayIndex];
}

export function getEmailParts(email) {
  let emailParts = [''];
  const decodedEmail = decodeURIComponent(email);
  try {
    emailParts = decodedEmail.split('@');
  } catch (error) {
    trackError(error);
  }
  return emailParts;
}

export function getRegionByCountryCode(code) {}

export function convertDate(date, from, to) {
  return format(parse(date, from, new Date()), to);
}

export function formatDate(date = new Date(), to = 'yyyy-MM-dd') {
  return format(date, to);
}

export function modifyDate(date, modifier, to = 'yyyy-MM-dd') {
  const parsed = parse(date, to, new Date());
  const result = modifier(parsed);

  return format(result, to);
}

export const filterNotExtistCountries = (countries = []) => {
  const COUNTRIES_CODES = Object.keys(COUNTRIES);

  return countries.filter(
    (item) => !NOT_EXIST_COUNTRIES.includes(item.country) && COUNTRIES_CODES.includes(item.country)
  );
};

export const filterNotExtistCountryNames = (countries = []) => {
  return countries.filter((country) => !NOT_EXIST_COUNTRIES.includes(country));
};

export const isIosDevice = () => {
  const re = /iP(ad|hone|od)/;

  if (typeof window !== 'undefined') {
    if (window.navigator && window.navigator.userAgent) {
      return re.test(window.navigator.userAgent);
    }
  }

  return false;
};

export const getMobileDevicePlatform = () => {
  const iosRegex = /iP(hone|od|ad)/;
  const androidRegex = /Android/;

  if (typeof window !== 'undefined') {
    if (window.navigator && window.navigator.userAgent) {
      const userAgent = window.navigator.userAgent;

      if (iosRegex.test(userAgent)) {
        return 'ios';
      }

      if (androidRegex.test(userAgent)) {
        return 'android';
      }
    }
  }

  return '';
};
